<template>

    <div class="container-fluid">
        <div class="row">
            <div class="col-6">

            </div>
            <div class="col-6">
                <ol style="float: right;" class="breadcrumb ">
                    <a v-show="opcrud > 0" @click.prevent="mtdcancelaredicao()"
                        class="btn btn-info btn-sm button-voltar"><i class="fa fa-arrow-alt-circle-left"></i>
                        Voltar</a>

                    <li style="padding-left: 15px;" class="breadcrumb-item"><a href="/inicio">Início</a></li>
                    <li class="breadcrumb-item"><a @click.prevent="mtdcancelaredicao()">Jornadas</a></li>
                    <li class="breadcrumb-item active">{{ descop.toLocaleLowerCase() }}</li>
                </ol>
            </div>

        </div>
        <div id="pnlista">


            <div class="card mb-3">
                <div class="card-header">
                    <div class="row">
                        <div class="col-lg-12">
                            <a @click.prevent="mtdnovo()" class="btn btn-info">
                                <i class="bi bi-calendar-plus"></i> Nova Jornada
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mb-3">
                <div class="card-header">
                    <div class="row">
                        <div class="col-lg-2">
                            <div class="form-group">
                                <label for="edtipopesq">Por</label>
                                <select class="form-select form-control" v-model="pfiltro"
                                    aria-label="Default select example">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label for="">pesquisa</label>
                                <input type="text" v-model="pconteudo" class="form-control" id="nome" required="">
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <div class="form-group">
                                <label for="">Limite
                                </label>
                                <select class="form-select form-control" v-model="pqtdregistros"
                                    aria-label="Default select example">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                    <option value="500">500</option>
                                    <option value="1000">1000</option>
                                    <option value="99999999">Todos</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-2" style="padding-top: 25px;">
                            <a @click.prevent="mtdexecutapesquisa()" style="width: 100%;" class="btn btn-info">
                                <i class="bi bi-search"></i> Listar
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <EasyDataTable :headers="headers" :items="lstjornadas" :pagination="false" hide-footer
                        empty-message="Nenhum dado encontrado"
                        table-class-name="table table-hover text-nowrap table-bordered table-striped">
                        <template #item-acoes="{ id }">
                            <div style="display: flex; justify-content: center;">
                                <a @click="mtdalterar(id)" class="btn btn-sm btn-warning">
                                    <i class="bi bi-pencil-square"></i>
                                </a>
                                <button style="margin-left: 15px;" type="button" class="btn btn-sm btn-danger"
                                    @click="mtdexcluir(id)">
                                    <i class="bi bi-trash"></i>
                                </button>
                            </div>
                        </template>

                        <template #item-nome="{ tipo, nome }">
                            {{ nome }}
                        </template>
                    </EasyDataTable>
                </div>
                <div class="card-footer">
                    <div class="container">
                        <div class="row">

                            <div class="col-12">
                                <vue-awesome-paginate :total-items="pqtd_total_registros" :items-per-page="pqtdregistros"
                                    :max-pages-shown="2" v-model="pagina_atual" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="pncadastro">
            <div class="card">
                <div class="card-body">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-2">
                                <div class="form-group">
                                    <label for="edid">Código</label>
                                    <input type="text" v-model="vid" class="form-control" id="edid" disabled>
                                </div>
                            </div>
                            <div class="col-lg-10">
                                <div class="form-group">
                                    <label for="ednome">Nome da Jornada</label>
                                    <input type="text" v-model="vnome" :disabled="ativadesativa" class="form-control"
                                        id="ednome">
                                </div>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-lg-3">
                                <div class="form-group">
                                    <label for="edhora_entrada">Hora de Entrada</label>
                                    <input type="time" v-model="vhora_entrada" :disabled="ativadesativa"
                                        class="form-control" id="edhora_entrada">
                                </div>
                            </div>
                            <div class="col-lg-3">
                                <div class="form-group">
                                    <label for="edhora_inicio_intervalo">Início Intervalo</label>
                                    <input type="time" v-model="vhora_inicio_intervalo" :disabled="ativadesativa"
                                        class="form-control" id="edhora_inicio_intervalo">
                                </div>
                            </div>
                            <div class="col-lg-3">
                                <div class="form-group">
                                    <label for="edhora_fim_intervalo">Fim Intervalo</label>
                                    <input type="time" v-model="vhora_fim_intervalo" :disabled="ativadesativa"
                                        class="form-control" id="edhora_fim_intervalo">
                                </div>
                            </div>
                            <div class="col-lg-3">
                                <div class="form-group">
                                    <label for="edhora_saida">Hora saída</label>
                                    <input type="time" v-model="vhora_saida" :disabled="ativadesativa"
                                        class="form-control" id="edhora_saida">
                                </div>
                            </div>
                        </div>
                        
                        <div class="row mt-3">
                            <div class="col-lg-12">
                                <div class="form-group">
                                    <label>Dias da Semana (Selecione um ou mais)</label>
                                    <div>
                                        <div class="form-check form-check-inline"
                                            v-for="(dia, index) in ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']"
                                            :key="index">
                                            <input class="form-check-input" type="checkbox" :disabled="ativadesativa"
                                                :id="'checkDia' + index" :value="index.toString()" v-model="vdias_semana">
                                            <label class="form-check-label" :for="'checkDia' + index">{{ dia }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="card-footer">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-10 col-md-10 col-sm-12">

                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-12">
                                <button v-show="opcrud == 1" :disabled="validou" @click.prevent="mtdgravar()"
                                    style="width: 100%;" id="btgravar" class="btn btn-info">
                                    <i class="bi bi-save"></i> Gravar
                                </button>
                                <button v-show="opcrud == 2" :disabled="validou" @click.prevent="mtdgravar()"
                                    style="width: 100%;" id="btgravar" class="btn btn-warning">
                                    <i class="bi bi-pencil"></i> Alterar
                                </button>
                                <button v-show="opcrud == 3" :disabled="validou" @click.prevent="mtdgravar()"
                                    style="width: 100%;" id="btgravar" class="btn btn-danger">
                                    <i class="bi bi-trash"></i> Excluir
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>

//Eu sou o caminho, a verdade e a vida. Ninguém vem ao Pai senão por mim. (João 14:6);


// @ is an alias to /src
import Swal from 'sweetalert2'
import util from '../util.js'
import EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import router from '@/router/index.js';


import { ref } from "vue";

const onClickHandler = (page) => {
    console.log(page);
};

const pagina_atual = ref(1);


// Mapeamento de índices para nomes de dias da semana para exibição na tabela
const diasMapeamento = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];


export default {
    name: 'jornadas', // Renomeado

    data() {
        return {

            //variaveis do cadastro - JORNADAS 
            opcrud: 0,
            vid: 0,
            vnome: '',
            vhora_entrada: '08:00', // NOVO
            vhora_inicio_intervalo: '12:00', // NOVO
            vhora_fim_intervalo: '13:00', // NOVO
            vhora_saida: '18:00', // NOVO
            vdias_semana: [], // NOVO (Array de strings com os índices dos dias: "1", "2", etc)
            vtipo: 0,

            modulo: 'JORNADAS DE TRABALHO', // Renomeado
            descop: '',

            //paginação
            pqtd_total_registros: 10,
            pagina_atual: 1,
            pqtdregistros: 10,
            pqtd_paginas: 0,


            //filtros
            pfiltro: 1,
            pconteudo: '',

            ativadesativa: false,

            headers: [ // Novos cabeçalhos da tabela
                { text: 'Ações', value: 'acoes', sortable: false, width: 80 },
                { text: 'Nome', value: 'nome', sortable: true },
                { text: 'Entrada', value: 'hora_entrada', sortable: true },
                { text: 'Início Int.', value: 'hora_inicio_intervalo', sortable: true },
                { text: 'Fim Int.', value: 'hora_fim_intervalo', sortable: true },
                { text: 'Dias', value: 'dias_semana', sortable: true },
            ],


            lstjornadas: [ // Renomeado para lstjornadas
            ]

        }
    },
    components: {
        EasyDataTable,

    },

    methods: {
        mtdfiltropesquisa() {
            let rfiltro = '';
            if (parseInt(this.pfiltro) === 0) {
                rfiltro = this.pconteudo === '' ? '' : ' and g.id=' + this.pconteudo;
            } else {
                rfiltro = this.pconteudo === '' ? '' : ' and g.upper(nome) like upper("' + this.pconteudo + '%")';
            }
            return rfiltro;
        },
        mtdexecutapesquisa() {
            var vself = this;
            let filtro = vself.mtdfiltropesquisa();
            this.pagina_atual = 1;
            let parametros = [
                { parametro: 'idusuario', valor: vself.$store.state.usuario.idusuario },
                { parametro: 'op', valor: 'qtdregistros' },
                { parametro: 'idempresa', valor: vself.$store.state.usuario.idempresa },
                { parametro: 'filtro', valor: filtro }
            ];
            // URL do controlador alterada
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/jornadas.php'); 
            retorno.then(function (response) {
                vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                let qtdpg = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                vself.pqtd_paginas = qtdpg > 0 ? qtdpg : 1;
                vself.mtdcarregaitem(1);
            }).catch(function (response) {
                //alert('Erro ao consultar registros');
            });
        },
        mtdcarregaitem(ipagina) {
            let vself = this;
            let filtro = vself.mtdfiltropesquisa();
            vself.$loading.show();
            let parametros = [
                { parametro: 'op', valor: 'listagem' },
                { parametro: 'idusuario', valor: vself.$store.state.usuario.idusuario },
                { parametro: 'idempresa', valor: vself.$store.state.usuario.idempresa },
                { parametro: 'filtro', valor: filtro },
                { parametro: 'limit', valor: vself.pqtdregistros },
                { parametro: 'offset', valor: (parseInt(ipagina) - 1) * parseInt(vself.pqtdregistros) },
            ];
            // URL do controlador alterada
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/jornadas.php'); 
            retorno.then(function (response) {
                // Mapeia os dias da semana para string antes de exibir na tabela
                vself.lstjornadas = JSON.parse(JSON.stringify(response.data)).map(item => ({
                    ...item,
                    dias_semana: item.dias_semana ? item.dias_semana.split(',').map(d => diasMapeamento[parseInt(d.trim())]).join(', ') : ''
                }));
                vself.$loading.hide();
            }).catch(function (response) {
                vself.lstjornadas = [];
                vself.$loading.hide();
            });
        },
        mtdpreparacrud(op) {
            this.opcrud = op;
        },
        resetarDados() {
            this.vid = '';
            this.vnome = '';
            this.vhora_entrada = '08:00'; // Valor padrão
            this.vhora_inicio_intervalo = '12:00'; // Valor padrão
            this.vhora_fim_intervalo = '13:00'; // Valor padrão
            this.vhora_saida = '18:00'; // Valor padrão
            this.vdias_semana = []; // Limpa seleção de dias
            this.vtipo = 0;

        },
        mtddefault() {
            $('#pnlista').hide();
            this.resetarDados();
            $('#pncadastro').fadeIn(700);
            this.$nextTick(function () {
                if (parseInt(this.opcrud) < 3) {
                    $('#ednome').focus(); // Foco no nome
                } else {
                    $('#btgravar').focus();
                }
            });
        },
        mtdpreparacrud(op) {
            this.opcrud = op;
            this.mtddefault();
        },
        mtdnovo() {


            this.descop = 'INCLUSÃO'
            this.ativadesativa = false;
            this.mtdpreparacrud(1);

        },
        mtdcancelaredicao() {
            this.descop = ''
            this.opcrud = 0;
            $('#pncadastro').hide();
            $('#pnlista').fadeIn(700);
            $('#edconteudopesq').focus();

        },

        mtdgravar() {
            let vself = this;
            Swal.fire({
                title: "Confirmação",
                text: 'Confirma ' + vself.descop + ' DE ' + vself.modulo + '?',
                icon: "warning",
                customClass: {
                    confirmButton: "conf btn btn-success",
                    cancelButton: "btn btn-danger"
                },
                showCancelButton: true,
                confirmButtonColor: "black",
                cancelButtonText: "Não",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sim"
            }).
                then((result) => {
                    if (result.isConfirmed) {
                        $('.conf').prop('disabled', true);
                        vself.mtdregistro();
                    } else {
                        $('#btgravar').focus();
                    }
                });
        },
        mtdlocalizaregistro(id) {
            var vself = this;
            let filtro = ' and g.id=' + id;
            let parametros = [
                { parametro: 'op', valor: 'listagem' },
                { parametro: 'idusuario', valor: vself.$store.state.usuario.idusuario },
                { parametro: 'idempresa', valor: vself.$store.state.usuario.idempresa },
                { parametro: 'filtro', valor: filtro },
                { parametro: 'limit', valor: 1 },
                { parametro: 'offset', valor: 0 },
            ];
            // URL do controlador alterada
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/jornadas.php');
            retorno.then(function (response) {
                // Aqui o retorno não está mapeado, para pegar os dados brutos
                let registroBruto = JSON.parse(JSON.stringify(response.data))[0];
                vself.mtdigualarcampos(registroBruto);

                if (parseInt(vself.opcrud) < 3) {
                    $('#ednome').focus();
                } else {
                    $('#btgravar').focus();
                }
            }).catch(function (response) {

            });
        },
        mtdalterar(id) {

            this.descop = 'ALTERAÇÃO'

            this.ativadesativa = false;
            this.mtdpreparacrud(2);
            this.mtdlocalizaregistro(id);

        },
        mtdexcluir(id) {

            this.descop = 'EXCLUSÃO'

            this.ativadesativa = true;
            this.mtdpreparacrud(3);
            this.mtdlocalizaregistro(id);

        },
        mtdigualarcampos(registro) { // Mapeamento dos novos campos do registro
            this.vid = registro.id;
            this.vnome = registro.nome;
            this.vhora_entrada = registro.hora_entrada;
            this.vhora_inicio_intervalo = registro.hora_inicio_intervalo;
            this.vhora_fim_intervalo = registro.hora_fim_intervalo;
            this.vhora_saida = registro.hora_saida;
            // Converte a string de dias ("1,2,3") para um Array de strings (["1", "2", "3"])
            this.vdias_semana = registro.dias_semana ? registro.dias_semana.split(',').map(d => d.trim()) : []; 
            this.vtipo = registro.tipo;

        },
        mtdregistro() {
            let vself = this;
            // Inclui os novos campos para envio ao backend
            let registrocrud = {
                'id': this.vid,
                'nome': this.vnome,
                'hora_entrada': this.vhora_entrada,
                'hora_inicio_intervalo': this.vhora_inicio_intervalo,
                'hora_saida': this.vhora_saida,
                'hora_fim_intervalo': this.vhora_fim_intervalo,
                // Converte o array de dias de volta para string ("1,2,3")
                'dias_semana': this.vdias_semana.join(','), 
                'tipo': this.vtipo,

            };
            let parametros = [
                { parametro: 'op', valor: 'rotinacrud' },
                { parametro: 'opcrud', valor: vself.opcrud },
                { parametro: 'idempresa', valor: vself.$store.state.usuario.idempresa },
                { parametro: 'registro', valor: JSON.stringify(registrocrud) },
                { parametro: 'idusuario', valor: vself.$store.state.usuario.idusuario },
            ];
            // URL do controlador alterada
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/jornadas.php'); 
            retorno.then(function (response) {
                if ($.isNumeric(response.data)) {
                    util.notif('success', 'Informação!', 'Registro processado com sucesso!');
                    vself.pfiltro = 0;
                    vself.pconteudo = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                    vself.pqtd_paginas = 1;
                    vself.mtdcancelaredicao();
                    vself.mtdcarregaitem(1);
                } else {
                    let tpret = response.data.substring(0, 1);
                    switch (tpret) {
                        case 'I':
                            util.notif('error', 'Informação!', response.data.substring(4));
                            break;
                        case 'E': default:
                            util.notif('error', 'Informação!', response.data.substring(4));
                            break;
                    }
                }
            }).catch(function (response) {
                alert('Erro ao processar o registo. Descrição do erro: ' + response.message)
            });
        },

    },
    computed: {
        validou() {
            // A validação agora exige que o Nome E pelo menos um Dia da Semana seja preenchido
            return this.vnome == '' || this.vdias_semana.length == 0
        }
    },
    mounted() {
        $loading.show()
        setTimeout(() => {

            this.$loading.hide()
            this.mtdexecutapesquisa();
        }
            , 1000)
        $('#pncadastro').hide();
    },
    watch: {
        pagina_atual(val) {
            this.mtdcarregaitem(val)
        }
    }
}
</script>
<style>
/* ... (Estilos CSS permanecem os mesmos) ... */
.pagination-container {
    display: flex;

    column-gap: 10px;
}

.paginate-buttons {


    border-radius: 20px;

    display: flex;

    cursor: pointer;

    background-color: rgb(242, 242, 242);

    border: 1px solid rgb(217, 217, 217);

    font-size: small;

    color: black;
}

.paginate-buttons:hover {
    background-color: #d8d8d8;
}

.active-page {
    background-color: #13534a;

    border: 1px solid #13534a;

    color: white;
}

.active-page:hover {
    background-color: #13534a;
}
</style>